<template>
  <div class="badge"
    :class="`badge_${type}`"
    >
    {{ label }}
  </div>
</template>

<script>
const availableTypes = {
  vibrant: 'vibrant', // purple bg, white text
  muted: 'muted', // light-grey bg, dark-grey text
  new: 'new' // light-green bg, bright-green text
}
export default {
  name: 'BaseBadge',
  props: {
    type: {
      type: String,
      default: availableTypes.vibrant,
      validator: (value) => {
        return Object.values(availableTypes).includes(value)
      }
    },
    label: {
      type: String,
      required: true
    }
  }
}
</script>   

<style lang="scss" scoped>
.badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;

  &_vibrant {
    background-color: $rfx-dark-purple;
    color: #fff;
  }

  &_muted { 
    background-color: $rfx-light-steel;
    color: $rfx-text-dark-mid-contrast;
  }

  &_new {
    background-color: $rfx-primary-200;
    color: $rfx-bright-turquoise;
  } 
}
</style>



